<template>
  <div class="notfound-container" @click="logout">
    <el-card class="notfound-card">
      <div class="wrap">
        <img src="~@/assets/shield_black.svg" alt="nrl" class="logo" />
      </div>
      <h4>Welcome to MySideline - your new competition and participant management system.</h4>
      <h4>
        To access your club information please contact your League representative or simply attend
        an on-boarding session near you soon. For more information please visit our information
        <a
          href="https://www.playrugbyleague.com/clubs/upgrade/clubsleagues/mysideline-preview"
          target="_blank"
        >
          page
        </a>
      </h4>
      <h4>
        By progressing to MySideline, you agree to abide by the policies of NRL as published at
        <a href="https://www.playrugbyleague.com/policies" target="_blank">
          https://www.playrugbyleague.com/policies
        </a>
        AND to access, use and/disclose information regarding registered participants only for the
        purposes of club administration and not to misuse or share any data contained within
        MySideline.
      </h4>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "PendingRole",
  props: {},
  created() {},
  data() {
    return {};
  },
  methods: {
    logout() {
      this.$store.commit("user/logout");
      this.$router.push("/login");
    }
  },
  computed: {}
};
</script>

<style scoped lang="scss">
.wrap {
  height: 117px;
  max-height: 117px;
  text-align: center;
  .logo {
    max-height: 100%;
  }
}
.notfound-container {
  min-height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;

  .notfound-card {
    margin-top: 2rem;
    width: 75%;
    max-width: 100%;
    text-align: center;
    a {
      word-wrap: break-word;
    }
  }
  @media only screen and (max-width: $sm) {
    .notfound-card {
      width: 90%;
    }
  }
}
</style>
